import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoParticulierRapidite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5588 3.55882V1.73529H16.5882C16.7941 1.73529 16.9412 1.55882 16.9412 1.38235C16.9412 1.20588 16.7941 1 16.5882 1H11.7941C11.5882 1 11.4412 1.17647 11.4412 1.35294C11.4412 1.52941 11.6176 1.70588 11.7941 1.70588H13.8235V3.52941C10.5294 3.67647 7.47058 5.47059 5.7647 8.35294C5.64705 8.52941 5.70587 8.76471 5.88235 8.85294C6.05882 8.97059 6.29411 8.91176 6.38235 8.73529C7.99999 5.97059 11 4.26471 14.2059 4.26471C19.2059 4.26471 23.2647 8.32353 23.2647 13.3235C23.2647 18.3235 19.2059 22.4118 14.2059 22.4118C11.2353 22.4118 8.44117 20.9412 6.73529 18.5C6.61764 18.3235 6.38235 18.2941 6.23529 18.4118C6.05882 18.5294 6.0294 18.7647 6.14705 18.9118C7.97058 21.5588 11 23.1471 14.2059 23.1471C19.6176 23.1471 24 18.7647 24 13.3529C24 8.05882 19.7941 3.76471 14.5588 3.55882Z",
				fill: "#1E1E1E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0294 15.9118C9.91176 15.7353 9.70588 15.6765 9.52941 15.7941C9.35294 15.9118 9.29412 16.1176 9.41176 16.2941C10.4412 18 12.2647 19 14.2353 19C17.3529 19 19.8824 16.4706 19.8824 13.3529C19.8824 10.2353 17.3529 7.70587 14.2353 7.70587C12.0294 7.70587 10 8.99999 9.08823 11.0294C9 11.2059 9.08823 11.4412 9.26471 11.5294C9.44118 11.6176 9.67647 11.5294 9.76471 11.3529C10.5588 9.58823 12.3235 8.47058 14.2353 8.47058C16.9412 8.44117 19.1177 10.647 19.1177 13.3529C19.1177 16.0588 16.9118 18.2647 14.2059 18.2647C12.5 18.2647 10.9118 17.3823 10.0294 15.9118Z",
				fill: "#1E1E1E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2059 13.3529C15.2059 12.7941 14.7647 12.3529 14.2059 12.3529C13.6471 12.3529 13.2059 12.7941 13.2059 13.3529C13.2059 13.9117 13.6471 14.3529 14.2059 14.3529C14.7647 14.3529 15.2059 13.9117 15.2059 13.3529ZM13.4706 13.3529C13.4706 12.9411 13.8235 12.5882 14.2353 12.5882C14.6471 12.5882 15 12.9411 15 13.3529C15 13.7647 14.6471 14.1176 14.2353 14.1176C13.7941 14.1176 13.4706 13.7647 13.4706 13.3529Z",
				fill: "#2188E5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.29413 11.3823H6.08825C6.14707 11.3823 6.20589 11.3235 6.20589 11.2647C6.20589 11.2059 6.14707 11.147 6.08825 11.147H2.29413C2.23531 11.147 2.17648 11.2059 2.17648 11.2647C2.17648 11.3235 2.20589 11.3823 2.29413 11.3823Z",
				fill: "#2188E5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.20589 15.8235C6.20589 15.7647 6.14707 15.7059 6.08825 15.7059H2.29413C2.23531 15.7059 2.17648 15.7647 2.17648 15.8235C2.17648 15.8823 2.23531 15.9412 2.29413 15.9412H6.08825C6.14707 15.9412 6.20589 15.8823 6.20589 15.8235Z",
				fill: "#2188E5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.02941 13.5294C4.02941 13.4706 3.97059 13.4117 3.91176 13.4117H0.117647C0.0588235 13.4117 0 13.4706 0 13.5294C0 13.5882 0.0588235 13.647 0.117647 13.647H3.91176C4 13.647 4.02941 13.5882 4.02941 13.5294Z",
				fill: "#2188E5"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 22.1471,
			fill: "white",
			transform: "translate(0 1)"
		})
	}) })]
});
export default SvgPictoParticulierRapidite;
